import { createPrefixer } from '.'

const ROOT = 'ver-administracion-pg' as const

export const RESOURCE_ADMINISTRACION_PG = 'Administracion PG' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pm = createPrefixer(ROOT, 'mantenimiento')
const pc = createPrefixer(ROOT, 'configuracion')

/**
 * Arbol de permisos de Administracion
 */

const permission = {
    _root: ROOT,
    _resource: RESOURCE_ADMINISTRACION_PG,
    mantenimiento: {
        _perm: rp('mantenimiento'),
        unidadNegocio: pm('unidad-negocio'),
        establecimiento: pm('establecimiento'),
        macrodepartamento: pm('macrodepartamento'),
        departamento: pm('departamento'),
        edificio: pm('edificio'),
        proceso: pm('proceso'),
        area: pm('area'),
    },
    configuracion: {
        _perm: rp('configuracion'),
        usuariosCompras: pc('usuarios-compras'),
        permisosEstructuraOrganizacional: pc('permisos-estructura-organizacional'),
    },
}

export default permission
